import { normalizeCategory } from './normalize-category'

export const normalizeLayoutCategory = (rawData) => {
  const {
    z_order: zOrder = '0',
    current_code: currentCode = '',
    category_list: categoryList = [],
  } = rawData

  return {
    zOrder,
    currentCode,
    categoryList: categoryList?.map(normalizeCategory),
  }
}
